export const DELAYED_CARD_STATUS_KEY = "delayed";
